import React from "react";
import "../../libraries/spectrum";

class Colorpicker extends React.Component {
  constructor(props) {
    super(props);

    this.color_input = React.createRef();
    this.state = {
      color: this.props.color || "",
    };
  }

  componentDidMount() {
    if (this.color_input && !this.props.read_only) {
      $(this.color_input.current).spectrum({
        allowEmpty: true,
        preferredFormat: "hex",
        cancelText: I18n.t("cancel"),
        chooseText: I18n.t("select"),
        clickoutFiresChange: false,
        showButtons: true,
        showInput: true,
        change: (color) => {
          this.setState({ color: color ? color.toHexString() : "" }, () => {
            if (typeof this.props.onChange === "function") {
              this.props.onChange({
                target: {
                  name: this.props.name,
                  value: this.state.color,
                },
              });
            }
          });
        },
        color: this.state.color,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.color != this.props.color) {
      $(this.color_input.current).spectrum({
        color: this.props.color,
      });
      this.setState({
        color: this.props.color,
      });
    }

    if (this.color_input && !this.props.read_only) {
      $(this.color_input.current).spectrum({
        allowEmpty: true,
        preferredFormat: "hex",
        cancelText: I18n.t("cancel"),
        chooseText: I18n.t("select"),
        showButtons: true,
        showInput: true,
        change: (color) => {
          this.setState({ color: color ? color.toHexString() : "" }, () => {
            if (typeof this.props.onChange === "function") {
              this.props.onChange({
                target: {
                  name: this.props.name,
                  value: this.state.color,
                },
              });
            }
          });
        },
        color: this.state.color,
      });
    }

    if (this.props.error) {
      $(this.color_input.current).next().addClass("has-errors");
    }

    if (prevProps.error && !this.props.error) {
      $(this.color_input.current).next().removeClass("has-errors");
    }
  }

  render() {
    if (this.props.read_only) {
      return (
        <div
          className={
            this.props.pullRight ? "color-swatch pull-right" : "color-swatch"
          }
          style={{
            backgroundColor: this.state.color,
            width: this.props.width || 22,
            height: this.props.height || 22,
            border: "1px solid #111",
          }}
        ></div>
      );
    } else {
      return (
        <div className="color-picker">
          <div className="color-picker-overlay"></div>
          <input
            ref={this.color_input}
            type="text"
            className={
              this.props.error ? "form-control has-errors" : "form-control"
            }
            name={this.props.name}
          />
          {this.props.error ? (
            <div className="help-block color-picker-help-block">
              <ul>{I18n.t("cant_be_blank")}</ul>
            </div>
          ) : null}
        </div>
      );
    }
  }
}

export default Colorpicker;
